import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { webDtos } from '@vectronic/openApi-admin';
import { DetailsItemComponent } from '../../details/details-item/details-item.component';

@Component({
  selector: 'vectronic-events-status',
  templateUrl: './events-status.component.html',
  styleUrls: ['./events-status.component.scss'],
  imports: [CommonModule, DetailsItemComponent, MatTabsModule],
})
export class EventsStatusComponent {
  id = input<number>();
  isLoading = input<boolean>();
  statusEvents = input<webDtos.EventDetailsForCollar>();
}
